import { ApiChatAttachmentKind, type ChatDialogAttachmentResponse } from '@/core/generated/api';
import { getHttpUrl } from '@/shared/lib/httpUrl';
import { getFileMediaKind } from '@/shared/lib/fileMediaKind';
import classes from '../ChatDialogPage.module.scss';

interface ChatDialogAttachmentProps {
    attachment: ChatDialogAttachmentResponse;
}

/** Показывает вложение сообщения */
export const ChatDialogAttachment = ({ attachment }: ChatDialogAttachmentProps) => {
    const url = getHttpUrl(attachment.url);
    const preview = getHttpUrl(attachment.previewUrl);
    const declaredKind = attachment.kind?.id;

    const kind = declaredKind && declaredKind !== ApiChatAttachmentKind.Unknown
        ? declaredKind
        : getFileMediaKind(url ?? '', attachment.mimeType);

    const name = attachment.fileName
        || (declaredKind !== ApiChatAttachmentKind.Unknown && attachment.kind?.name)
        || 'Вложение';

    if (!url) return <span>Вложение недоступно: {name}</span>;

    if (kind === ApiChatAttachmentKind.Image) {
        return (
            <a
                className={classes.attachment}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Открыть изображение: ${name}`}
            >
                <img
                    src={preview ?? url}
                    alt={name}
                    loading="lazy"
                />
            </a>
        );
    }

    if (kind === ApiChatAttachmentKind.Audio) {
        return (
            <audio
                className={classes.media}
                src={url}
                controls
                preload="none"
                aria-label={name}
            >
                <a href={url}>{name}</a>
            </audio>
        );
    }

    if (kind === ApiChatAttachmentKind.Video) {
        return (
            <video
                className={classes.media}
                src={url}
                poster={preview ?? undefined}
                controls
                preload="none"
                aria-label={name}
            >
                <a href={url}>{name}</a>
            </video>
        );
    }

    return (
        <a
            className={classes.fileLink}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
        >
            {name}
        </a>
    );
};
